import { render, staticRenderFns } from "./AccountChoose.vue?vue&type=template&id=350722e5&scoped=true&"
import script from "./AccountChoose.vue?vue&type=script&lang=js&"
export * from "./AccountChoose.vue?vue&type=script&lang=js&"
import style0 from "./AccountChoose.vue?vue&type=style&index=0&id=350722e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350722e5",
  null
  
)

export default component.exports